import { render } from "./employee-dashboard.vue?vue&type=template&id=0aed2bb4"
import script from "./employee-dashboard.vue?vue&type=script&lang=js"
export * from "./employee-dashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__